import { PageLoading, SmartReportForm } from "@workleap-ai/shared";
import { Suspense } from "react";

const SmartReportsEditPage = () => {
    return (
        <Suspense fallback={<PageLoading />}>
            <SmartReportForm
                hasBackButton
                border="neutral-weak"
            />
        </Suspense>
    );
};

export default SmartReportsEditPage;
